import { makeStyles } from '@material-ui/core/styles';

const footerHeight = 70;

export const useStyles = makeStyles(() => ({
  sidebar: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 'scretch',
    minWidth: '240px',
    height: 'calc(100vh - 49px)',
    backgroundColor: '#323349',
  },
  smallSideBar: {
    position: 'relative',
    width: '57px',
    height: 'calc(100vh - 49px)',
    backgroundColor: '#323349',
  },
  sideBarContainer: {
    height: `calc(100% - ${footerHeight}px)`,
    minHeight: `calc(100% - ${footerHeight + 30}px)`,
    maxWidth: '240px',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-height: 430px)': {
      height: `calc(100% - ${(footerHeight + 10)}px)`,
      overflowY: 'auto'
    }
  },
  sidebarMenu: {
    margin: '0 10px',
    paddingLeft: '0',
    '& li': {
      backgroundColor: '#323349',
      listStyle: 'none',
      marginTop: '10px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#474A6B'
      },
    },
    '& a': {
      textDecoration: 'none',
      color: '#FFFFFF',
      display: 'block',
      padding: '7px',
      paddingLeft: '14px',
      whiteSpace: 'nowrap',
    },
  },
  sidebarMenuIcon: {
    position: 'relative',
    top: '3px',
    height: '22px',
    marginRight: '10px',
    cursor: 'pointer',
    zIndex: 20,
    paddingRight: '8px',
    pointerEvents: 'none'
  },
  sidebarMenuIconScan: {
    position: 'relative',
    top: '3px',
    left: '3px',
    height: '22px',
    marginRight: '15px',
    cursor: 'pointer',
    zIndex: 20,
    paddingRight: '8px',
  },
  sideBarText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    zIndex: 20,
    position: 'relative',
    bottom: '3px',
  },
  activeLink: {
    background: '#474A6B',
    borderLeft: 'solid 3px #ffffff',
    zIndex: 10,
    paddingLeft: '11px !important',
  },
  sidebarCardIcon: {
    position: 'relative',
    width: '22px',
    top: '3px',
    marginRight: '10px',
    zIndex: 20,
    paddingRight: '8px',
    pointerEvents: 'none'
  },
  sidebarPanel: {
    position: 'absolute',
    top: '0px',
    bottom: '35px',
  },
  footer: {
    paddingBottom: '35px',
    paddingLeft: '14px',
    width: '100%',
    height: `${footerHeight}px`,
    backgroundColor: '#323349',
    '& ul': {
      margin: '0px',
      paddingLeft: '0',
      '& li': {
        listStyle: 'none',
        marginTop: '10px',
        cursor: 'pointer',
      },
    },
  },
  sidebarDashboardIcon: {
    position: 'relative',
    top: '4px',
    height: '20px',
    marginRight: '10px',
    cursor: 'pointer',
    zIndex: 20,
  },
  moreHoriz: {
    color: 'white',
    '& a': {
      color: '#FFF',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      marginBottom: '20px',
    },
  },
  popover: {
    padding: '10px',
    '& ul': {
      margin: '0px',
      paddingLeft: '0',
      '& li': {
        listStyle: 'none',
        margin: '5px',
        '& a': {
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '12px',
        },
      },
    },
  },
  moreOnHoverButton: {
    position: 'relative',
    marginLeft: '-5px',
    borderRadius: '100%',
    width: '34px',
    height: '34px',
    '& *': {
      paddingTop: '4px',
      marginLeft: '5px',
    },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255, 0.21)',
    },
  },
}));
